import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PadraoSelect } from 'app/interfaces/compartilhados/Inputs';

@Component({
  selector: 'app-select-padrao',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './select-padrao.component.html',
  styleUrl: './select-padrao.component.css'
})
export class SelectPadraoComponent {
  @Input() public dadosSelect!: PadraoSelect[]; 
  @Input() public imgSrc!: string;
  @Input() public width: number = 13.5;
  @Input() public label!: string;
  @Input() public alt: string = "";

  @Output() eventoSelect = new EventEmitter<string | null>();

  public pegarValorAtual(event:Event) {
    const valorSelecionado: string = (event.target as HTMLSelectElement).value;
    this.emitirValorSelecionado(valorSelecionado);
  }

  public emitirValorSelecionado(valorSelecionado: string) { 
    this.eventoSelect.emit(valorSelecionado == 'null' ? null : valorSelecionado)
  }
}
